import React from 'react';

export default function PromptConfirmDAppointment({ show, setViewMode, doAppointmentCreate }) {

    if (show) {

        return (
            <div className="modal fade show" id="confirmAppointmentModal" aria-modal="true" role="dialog" style={{ display: "block" }} >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body">
                            <h2>Proceed with the appointment request?</h2>
                            <p>An email will be sent to the partner</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-light" onClick={() => setViewMode('')}> No </button>
                            <button type="button" className="btn btn-primary" onClick={() => doAppointmentCreate()}> Yes </button>
                        </div>
                    </div>
                </div>
            </div>
        );

    } else { return null; }

}